export const ignoredEndpoints = [
  'drop-down-data',
  'legends',
  'soc-range',
  'vehicle-saving',
  'overspeed-graph',
  'energy-efficiency',
  'vehicles-list',
  'geo-fence',
  'admin-data',
  'audit-log',
  'distance-energy-efficiency-graph',
  'distance-energy-graph',
  'utilization-graph',
  'trip-report',
  'charging',
  'trip-graph',
  'vehicle-information',
  'geozone',
];
